import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const STATS = [
  { key: "monthly-payment", label: "Monthly Payment", value: "—" },
  { key: "next-due-date", label: "Next Due Date", value: "—" },
  { key: "remaining", label: "Remaining", value: "—" },
  { key: "payments-left", label: "Payments Left", value: "—" },
];

const TABLE_HEAD_CLASS = "px-6 py-3 text-xs uppercase tracking-wider text-muted-foreground";

export function PolicyBillingTab() {
  return (
    <div className="space-y-6" data-testid="policy-billing">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {STATS.map((stat) => (
          <div
            key={stat.key}
            className="rounded-xl border border-border bg-card px-5 py-4"
            data-testid={`policy-billing-stat-${stat.key}`}
          >
            <p className="text-[10px] font-bold tracking-wider text-muted-foreground uppercase">
              {stat.label}
            </p>
            <p className="text-2xl font-semibold text-foreground mt-1">
              {stat.value}
            </p>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className={TABLE_HEAD_CLASS}>Type</TableHead>
              <TableHead className={TABLE_HEAD_CLASS}>Due Date</TableHead>
              <TableHead className={TABLE_HEAD_CLASS}>Amount</TableHead>
              <TableHead className={TABLE_HEAD_CLASS}>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell colSpan={4} className="px-6 py-12 text-center text-sm text-muted-foreground">
                Billing schedule coming soon.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
